import { z } from 'zod';
import { efemLoadPortBindingStatusSchema, EfemLoadPortBindingViewSchema, } from './efem-barcode.schemas.js';
/** Handheld bind session — preview row per load port (Redis, not Postgres until confirm). */
export const HandheldBindPreviewEntrySchema = z.object({
    loadPortId: z.number().int().positive(),
    rawBarcode: z.string(),
    normalizedBarcode: z.string().nullable(),
    resolutionStatus: efemLoadPortBindingStatusSchema,
    containerId: z.number().int().positive().nullable(),
    containerName: z.string().nullable().optional(),
    containerBarcode: z.string().nullable().optional(),
    conflictLoadPortId: z.number().int().positive().nullable().optional(),
    scannerSerialNumber: z.string(),
    scannedAt: z.string(),
});
export const ArmHandheldBindSchema = z.object({
    loadPortId: z.number().int().positive(),
});
export const HandheldBindPreviewResponseSchema = z.object({
    success: z.literal(true),
    data: z.object({
        armedLoadPortId: z.number().int().positive().nullable(),
        previews: z.array(HandheldBindPreviewEntrySchema),
    }),
});
export const ConfirmHandheldBindSchema = z.object({
    forceRebind: z.boolean().optional(),
});
export const ConfirmHandheldBindResponseSchema = z.object({
    success: z.literal(true),
    data: z.object({
        bindings: z.array(EfemLoadPortBindingViewSchema),
    }),
});
//# sourceMappingURL=efem-handheld-barcode.schemas.js.map